import React from 'react';
import { Table, Button } from 'react-bootstrap';

/**
 * Componente que renderiza a tabela de comprovantes.
 * @param {Array} comprovantes - Lista de comprovantes a serem exibidos.
 * @param {Function} onEdit - Função chamada ao clicar no botão de edição.
 * @param {Function} onDelete - Função chamada ao clicar no botão de remoção.
 */
function ComprovanteTable({ comprovantes, onEdit, onDelete }) {
    return (
        <div id="table">
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Status</th>
                        <th>Download</th>
                        <th>Tipo</th>
                        <th>Descrição</th>
                        <th>Valor</th>
                        <th>Data de Pagamento</th>
                        <th>Informações</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {comprovantes.map((comprovante, index) => (
                        <tr key={comprovante.id}>
                            <td>{index + 1}</td>
                            <td>
                                <i
                                    className="fas fa-money-bill-wave bg-green center-element"
                                    title={comprovante.status}
                                    id="money"
                                ></i>
                            </td>
                            <td>
                                <a
                                    href={`https://guias.almeidaenogueira.com.br/api/download/pagamento/${comprovante.id}`}
                                    style={{ color: 'green' }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fa fa-cloud-download mr-3"></i>
                                    {comprovante.anexo}
                                </a>
                            </td>
                            <td>{comprovante.tipo}</td>
                            <td>{comprovante.descricao}</td>
                            <td>{comprovante.valor}</td>
                            <td>{comprovante.data_pagamento}</td>
                            <td>
                                {comprovante.nome ? (
                                    <>
                                        <strong>Nome:</strong> {comprovante.nome}<br />
                                        <strong>CPF/CNPJ:</strong> {comprovante.cpf}<br />
                                        <strong>AGÊNCIA:</strong> {comprovante.agencia}<br />
                                        <strong>CONTA:</strong> {comprovante.conta}<br />
                                        <strong>BANCO:</strong> {comprovante.banco}
                                    </>
                                ) : (
                                    <></>
                                )}
                            </td>
                            <td>
                                <Button
                                    variant="danger"
                                    size="sm"
                                    onClick={() => onDelete(comprovante.id)}
                                >
                                    <i className="fa fa-trash"></i>
                                </Button>
                                <Button
                                    variant="info"
                                    size="sm"
                                    style={{ marginLeft: '10px' }}
                                    onClick={() => onEdit(comprovante.id)}
                                >
                                    <i className="fa fa-edit"></i>
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
}

export default ComprovanteTable;
